import { getElement } from './dom';

/** How long a piece needs to clear the bottom of the screen, worst case. */
const CLEANUP_MS = 5000;
const DEFAULT_EMOJIS = ['🎉', '⭐', '💛', '🧡', '💙', '🎊'] as const;

export interface ConfettiOptions {
  /** How many pieces to drop. */
  pieces?: number;
  /** Which emoji to rain; each piece picks one at random. */
  emojis?: readonly string[];
  /** Layer to drop them into — a fixed, pointer-transparent overlay. */
  layer?: string;
  random?: () => number;
}

/**
 * Emoji rain for a win. Pieces remove themselves once they are off screen: a
 * child can win many times in one sitting, and the layer would otherwise keep
 * every piece of every celebration in the DOM.
 */
export function dropConfetti({
  pieces = 24,
  emojis = DEFAULT_EMOJIS,
  layer = '#confetti-layer',
  random = Math.random,
}: ConfettiOptions = {}): void {
  const target = getElement(layer);
  for (let i = 0; i < pieces; i += 1) {
    const piece = document.createElement('span');
    piece.className = 'confetti';
    piece.textContent = emojis[Math.floor(random() * emojis.length)];
    piece.style.left = `${random() * 100}vw`;
    piece.style.animationDuration = `${2 + random() * 2.4}s`;
    piece.style.animationDelay = `${random() * 0.7}s`;
    target.append(piece);
    window.setTimeout(() => piece.remove(), CLEANUP_MS);
  }
}
